import { MsalProvider } from "@azure/msal-react";
import { setupStore } from "@src/setupStore";
import { App as AntApp, ConfigProvider } from "antd";
import { Provider } from "react-redux";

import "./App.css";
import { msalInstance } from "./auth";
import { extendDaysjsPlugins } from "./dayjs_plugins";
import { defaultTheme } from "./stylings/antd_theme";
import { initializeFaro } from "./utils/faro";

import { ValidateAuth } from "@src/components/login";
import Router from "@src/router/Router";

extendDaysjsPlugins();

initializeFaro();

function App() {
  return (
    <ConfigProvider theme={defaultTheme}>
      <AntApp>
        <Provider store={setupStore({})}>
          <div className="app-container">
            <MsalProvider instance={msalInstance}>
              <ValidateAuth>
                <Router />
              </ValidateAuth>
            </MsalProvider>
          </div>
        </Provider>
      </AntApp>
    </ConfigProvider>
  );
}

export default App;
